import { Text, Category } from './nodes';


export class Product{
    id : string
// Product 
    item_id : string
    filter_id: string
    category_id: string
    brand_name : string
    image_url : string
    value_cents : number
    unit_measure : string
    value_x_unit : number
    has_format : boolean
    characteristics : Characteristic[]
    texts : Text[]
    available : boolean
// Product offer
    end_date : string
    new_value_cents : number
    band_uri : string
    chip_color : string
// Product promo
    promo_id : string
    qty_required : number
// Product comby
    combinable_with : string[]
    formats : Format[]
// Product InputX
    promoX_required : boolean
    promoX_overlap : number
// Product OutputX
    promoX_cents : number
       
    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        this.chip_color = this.chip_color  ?  this.chip_color.replace( /;/g , ',' ) : '' ;
        if (this.characteristics){
            this.characteristics = this.characteristics.map(item => new Characteristic(item));
        }
        if (this.formats){
            this.formats = this.formats.map(item => new Format(item));
        }
        
    }
   
    get price () : number {
        if (this.inDiscount){
            return this.new_value_cents / 100;
        }
        return this.value_cents / 100;
    }

    get oldPrice () : number {
        return this.value_cents / 100;
    }
    
    get unitPrice() : number {
        return this.value_x_unit / 100;
    }

    get inDiscount () : boolean {
        return this.new_value_cents && this.new_value_cents != this.value_cents;
    }

    get inPromo() : boolean {
        return this.promo_id != null;
    }

    get inComby () : boolean {
        return this.combinable_with != null && this.combinable_with.length > 0;
    }

    get gift () : boolean {
        return this.promoX_cents != null && this.promoX_cents == 0;
    }

    getText(lang: string) : string {
        const text : Text = this.texts.find ( text => text.type == 4 && text.lang == lang )  
        return text ? text.text : '';
    }

    getOfferText(lang: string) : string {
        const text : Text = this.texts.find ( text => text.type == 6 && text.lang == lang )  
        return text ? text.text : '';
    }

    getFormats() {
        let service : Format = this.getServiceFormat();
        let formats : Format[];

        formats =  this.formats.filter( format => {
            return format.format_id != service.format_id;
        });

        return formats;
        
    }

    getServiceFormat()  : Format {
        let format : Format = null;

        if (this.formats.length > 0){
            // Cerca el format de servei : "format de servei"
            format = this.formats.find( format => {
                return format.getText('ca').toLowerCase().indexOf('format') === 0;
            });
            // si no l'ha trobat retornar el primer.
            if (!format){
                format = this.formats[0];
            }
        }       
        return format;

    }

    getServiceFormatOption(format_id : string, option_id : string)  : FormatOption {
        let format : Format = null;
        let formatOption : FormatOption = null;

        if (this.formats.length > 0){
            // Cerca el format de servei 
            format = this.formats.find( format => {
                return format.format_id === format_id;
            });
            
            if (format){
                formatOption = format.options.find( option =>{
                    return option.option_id === option_id;
                });
            }
        }

        return formatOption;
    }

    getBorderStyle() {

        if (this.chip_color && this.chip_color != "") 
        {
          return "border-left: 10px solid; border-color: rgba(" + this.chip_color + ")";
        }

          return ""
    }


}

export class Characteristic extends Category {
    embedded_icon_url : string

    constructor(values: Object = {}) {
        super(values,null);
        (<any>Object).assign(this, values);
    }
    
    getText(lang: string) : string {
        const text : Text = this.texts.find ( text => text.type == 5 && text.lang == lang )  
        return text ? text.text : '';
    }

}

export class Format {
    format_id : string
    title : Text[];
    options : FormatOption[]
    order : number

    
    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        this.title = this.title.map(item => new Text(item));
        this.options = this.options.map(item => new FormatOption(item));
    }

    getText(lang: string) : string {
        const title : Text = this.title.find ( title => title.type == 2 && title.lang == lang )  
        return title ? title.text : '';
    }
 


}

export class FormatOption{
    description : Text[]
    option_id: string
    min_value_mili : number
    max_value_mili: number
    interval_mili: number
    percentage_mili: number

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        this.description = this.description.map(item => new Text(item));
    }

    getText(lang: string) : string {
        const text : Text = this.description.find ( text => text.type == 3 && text.lang == lang )  
        return text ? text.text : '';
    }

    public get min() : number {
        return this.min_value_mili === 0 ? 1 : this.min_value_mili / 1000;
    }
    public get max() : number {
        return this.max_value_mili === 0 ? Number.MAX_VALUE :  this.max_value_mili / 1000;
    }
    public get interval() : number {
        return this.interval_mili === 0 ? 1 : this.interval_mili / 1000;
    }
    public get percent() : number {
        return this.percentage_mili === 0 ? 0 : this.percentage_mili / 1000;
    }

}

export class FileProduct {

    product : Product;
    filedetails : FileDetails
    ingredients : FileIngredients[];
    nutritionals : FileNutritionals[];
    allergens : FileAllergens[];
    allergensGrouped : Map<string, FileAllergens[]> = new Map();
    allergensGroups : string[]  = [];

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        this.product = new Product(this.product);
        this.ingredients = this.ingredients.map(item => new FileIngredients(item));
        this.nutritionals = this.nutritionals.map(item => new FileNutritionals(item));
        this.allergens = this.allergens.map(item => new FileAllergens(item));
        this.filedetails = new FileDetails(this.filedetails);

        this.allergens.forEach(allergen => {
            let arr : FileAllergens[];
            arr = this.allergensGrouped.get(allergen.alergendescription);
            if (! arr) {
                arr = [];
                this.allergensGroups.push(allergen.alergendescription);
                this.allergensGrouped.set(allergen.alergendescription,arr);
            }
            arr.push(allergen);
        });

    }

    public hasNutritional(key : string) : boolean{
        let has : boolean = false;
        this.nutritionals.forEach( nutritional => {
            has = has || nutritional[key]  != '';
        });
        return has;
    }
}

export class FileDetails{
    desc : string                   // Descripción del artículo en el ticket de compra (ahora no se utiliza en la web)
    etiqueta : string               // Texto que aparece en la etiqueta de la tienda. En la web se pasa a “descriptions” formateado como diccionario  
    descriptions : any              // 	Diccionario con los valores del campo etiqueta (opcional)
    ingredient_list : string        // Texto explicativo de los ingredientes del producto (opcional)
    conservation : string           // Texto explicativo de cómo se ha de conservar el producto (opcional) 
    netweight : string              // Peso Neto (opcional) 
    nutritionalrationvalue : string // Medida de una ración de producto (opcional) 
    foto : string                   // Foto del producto para el zoom (opcional) 
    additionaldata : string         // Texto para mensajes extendidos (opcional) 
    isingre : number                // Variable para saber si el producto tiene ingredientes (y cómo/de dónde se han de leer si los hay) 
    isnutritional : number          // Variable para saber si el producto tiene textos nutricionales   
    isallergens : number            // Variable para saber si el producto tiene textos sobre alérgenos   
    isextern : number               // Variable para saber si la información se ha obtenido externamente   
    extended : string               // Variable para saber si existe información extendida de producto y se ha de llamar al servicio de ficha extendida para obtenerla   

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        let map : Map<string,string> = new Map();
        Object.keys (this.descriptions).forEach (k => { 
            map.set(k, this.descriptions[k]);
        });
        this.descriptions = map;
        map.entries
    }
}

export class FileIngredients{
    ingrename : string              // Nombre del ingrediente (si es externo)
    ingrepercentatge : string       // Porcentaje del ingrediente (si es externo)   

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }

}

export class FileNutritionals {
    nutritionalname : string    // Nombre
    nutritionalunit : string    // Unitat
    per_100 : number            // Valor con decimales (con el punto como separador de decimales!!!)    
    per_ration : number         // Valor con decimales (con el punto como separador de decimales!!!)    
    per_product : number        // Valor con decimales (con el punto como separador de decimales!!!)    
    per_ingest : number         // Valor con decimales (con el punto como separador de decimales!!!)    

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }

}

export class FileAllergens {
    alergendescription : string    // Texto de si tiene o no el Alérgeno
    alergensname : string          // Nombre del Alérgeno

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }

}

//  Fitxa extessa (celler)

export class InfoExt{
    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }
}

export class InfoExt_Celler  extends InfoExt {
    Descripcio : string      // Texto
    Nom : string             // Texto
    Tipus : string           // Texto
    Color_tipus : string     // Texto
    Bodega : string          // Texto
    DO : string              // Texto
    Pais : string            // Texto
    Servir : string          // Texto
    Fustar : string          // Texto
    Formatr : string         // Texto
    Graduacio : string       // Texto
    TipusRaim : string       // Texto
    Moments : string[]       // Texto
    Categoria : string []    // Texto
    Maridatges : Maridatge[] // Texto
    MaridatgesGrouped :  Maridatge[]
    Vista : string[]         // Texto
    Nas : string[]           // Texto
    Boca : string[]          // Texto
    Coment : string          // Texto
    Foto : string            // Texto
    Premis : Premi[]         // Texto

    constructor(values: Object = {}) {
        super(values);
        this.Maridatges = this.Maridatges.map(item => new Maridatge(item));
        this.Premis = this.Premis.map(item => new Premi(item));

        this.MaridatgesGrouped = [];
        this.Maridatges.forEach( maridatge => {
            let m : Maridatge = null;
            m = this.MaridatgesGrouped.find( grouped => {
                return grouped.Agrupacio === maridatge.Agrupacio;
            });
            if (!m){
                this.MaridatgesGrouped.push(maridatge);

            }
        });
        

    }





}

export class Maridatge {
    Nom	: string
    Color : string
    Icono : string
    Agrupacio : string

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }
}

export class Premi {
    Nom	: string
    Any	 : string
    Punts : string

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }
}
